import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from "../../assets/Configuration";
import { TextTemplateModel } from '../models/text-templates/text-template.model';
import { TextTemplateCreationAndUpdateModel } from '../models/text-templates/text-template-creation-and-update.model';
import { TextTemplateTypeModel } from '../models/text-templates/text-template-type.model';

@Injectable({
  providedIn: 'root'
})
export class TextTemplateService {

    constructor(private httpClient: HttpClient) {
    }

    public getTextTemplate(id: string): Observable<TextTemplateModel> {
      return this.httpClient.get<TextTemplateModel>(
        Configuration.getApiBaseUrl() + "/text-templates/" + id
      );
    }

    public getAllTextTemplates(): Observable<TextTemplateModel[]> {
      return this.httpClient.get<TextTemplateModel[]>(
        Configuration.getApiBaseUrl() + "/text-templates"
      );
    }

    public getTextTemplatesByType(
      type: TextTemplateTypeModel
    ): Observable<TextTemplateModel[]> {
      return this.httpClient.get<TextTemplateModel[]>(
         Configuration.getApiBaseUrl() + "/text-templates/" + type
      );
    }

    public addTextTemplate(
      model: TextTemplateCreationAndUpdateModel
    ): Observable<TextTemplateModel> {
      return this.httpClient.post<TextTemplateModel>(
        Configuration.getApiBaseUrl() + "/text-templates",
        model
      );
    }

    public updateTextTemplate(
      id: string,
      model: TextTemplateCreationAndUpdateModel
    ): Observable<TextTemplateModel> {
      return this.httpClient.put<TextTemplateModel>(
        Configuration.getApiBaseUrl() + "/text-templates/" + id,
        model
      );
    }

    public deleteTextTemplate(id: string): Observable<void> {
      return this.httpClient.delete<void>(
        Configuration.getApiBaseUrl() + "/text-templates/" + id
      );
    }
}